import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import AreaChart from 'components/AreaChart';
import { useEventAnalyticsRevenueAllTime } from 'legacy/events/hooks/useEventRevenueAlltime';
import { currencyFormat } from 'legacy/common/utils/currency';
import Loader from 'legacy/common/components/layout/Loader';
import i18n from 'i18n';

const KeyMetricsFinancials = () => {
  const router = useRouter();

  const eventId = router.query.slug as string;

  const { data: revenueAllTime, isLoading } = useEventAnalyticsRevenueAllTime({
    eventId
  });

  const revenueAllTimeData = useMemo(() => {
    if (
      !revenueAllTime ||
      !revenueAllTime.data ||
      revenueAllTime.data.length === 0
    ) {
      return [];
    }

    return revenueAllTime.data.map((item) => {
      const formattedDate = item.date
        ? new Date(item.date).toLocaleDateString(i18n.language, {
            month: 'short',
            day: 'numeric'
          })
        : '';
      return {
        name: formattedDate,
        value: item.revenue,
        total: formattedDate
      };
    });
  }, [revenueAllTime?.data, isLoading]);

  if (isLoading) {
    return <Loader isLoading />;
  }

  return (
    <div>
      <div className="flex justify-center  space-y-4 mb-6">
        {revenueAllTimeData && (
          <AreaChart
            data={revenueAllTimeData}
            className="w-full"
            title="Gross revenue (all time)"
            subtitle={`${currencyFormat(revenueAllTime?.totalRevenue || 0)}`}
            type="currency"
          />
        )}
      </div>
    </div>
  );
};

export default KeyMetricsFinancials;
